import { Text, Card, Textarea, Code } from "@mantine/core";
import { Link } from "wouter";

export default function JobCard({ job }) {
  var pl = job.imagePayload;
  return (
    <Card>
      {job.type} {job.subType}
      <Text c="dimmed">User</Text>
      <Link to={`/admin/users/${job.userId}`}>{job.userId}</Link>

      {pl?
        <div>
        <Text c="dimmed">Model</Text>
        {pl.modelName} / {pl.sampler}<br />
        CFG: {pl.guidanceScale} <br />
        PS: {pl.promptStrength}<br />
        <Text c="dimmed">Lora</Text>
        {pl.lora} @ {pl.loraStrength}<br />
        <Text c="dimmed">Prompt</Text>
        <Textarea disabled autosize value={pl.prompt} />
        <Text c="dimmed">Negative</Text>
        <Textarea disabled autosize value={pl.negativePrompt} />
        <Text c="dimmed">Steps</Text>
        {pl.steps}<br />
        Seed: {pl.seed}<br />
        </div> : null}

      {job.result ? <Text>{job.result.width} x {job.result.height}</Text> : null}
      {job.retryCount} attempts {job.milliseconds}ms @'{job.machineName}'
      <Text c="dimmed" mt="xl">Details</Text>
      <Code block>
        {JSON.stringify(job, null, 2)}
      </Code>
    </Card>
  );
}



// [
//   {
//     id: "65c0a2e05328a3091b237dfc",
//     created: "2024-02-05T08:57:04Z",
//     status: "success",
//     started: "2024-02-05T08:57:35.247Z",
//     nextRun: null,
//     retryCount: 1,
//     recurrence: null,
//     milliseconds: 33158,
//     machineName: "6a749dc7-155b-4ad3-9bcb-cf0c57fe8fd6",
//     antecedence: 0,
//     subType: "SDXL-Generate",
//     userId: "65a58b45b7442f22731db34c",
//     imagePayload: {
//       ownerType: "user",
//       modelName: "omnigenxlNSFWSFW_v10",
//       vae: null,
//       clipSkip: false,
//       lora: "NsfwPovAllInOneLoraSdxl-000009",
//       loraStrength: 0.5,
//       sampler: "dpmpp_2m_sde",
//       initImageLogicalImageId: null,
//       initImageSha: null,
//       prompt:
//         "Woman, 20, Caucasian, Fit, Large Breasts, Auburn, School Uniform, Classroom, Double Penetration, ",
//       negativePrompt:
//         "(bad_pictures:0.7), negative_hand-neg, asian, Watermark, Text, censored, deformed, bad anatomy, disfigured, poorly drawn face, mutated, extra limb, ugly, poorly drawn hands, missing limb, floating limbs, disconnected limbs, disconnected head, malformed hands, long neck, mutated hands and fingers, bad hands, missing fingers, cropped, worst quality, low quality, mutation, poorly drawn, huge calf, bad hands, fused hand, missing hand, disappearing arms, disappearing thigh, disappearing calf, disappearing legs, missing fingers, fused fingers, abnormal eye proportion, Abnormal hands, abnormal legs, abnormal feet, abnormal fingers",
//       guidanceScale: 5,
//       width: 768,
//       steps: 30,
//       height: 1024,
//       watermark: null,
//       resultImageSha: "ca97ad643aca3b98cb23b4918f81549506035c9c",
//       resultImageWatermarkSha: "15463d97b857eab100d286ce8ff379ad7f83ec41",
//       resultLogicalImageId: "65c0a31f95795ca83c5fe509",
//       seed: 1723141518,
//       promptStrength: 0.5,
//       maxEdgeSize: 0,
//     },
//   },
// ];
